export default __webpack_public_path__ + "static/media/logo.c6c0e69d.svg";